import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { faBorderAll, faChevronDown, faChevronUp, faHome } from '@fortawesome/free-solid-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { SidenavService } from '../../services/sidenav.service';
import { UserService } from '../../services/user.service';
import { NavItem } from '../../interfaces/nav-item.interface';

@Component({
  selector: 'lm-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent implements OnInit {
  @Input() items!: NavItem[];

  public subItems!: NavItem[];
  public submenu = new Array();
  public selected_index?: number = 6;
  myLocation = window.location;
  public angleDown = faChevronDown;
  public angleUp = faChevronUp;
  subMenuIndex = -1;
  public faUser = faUser;
  public faGrid = faBorderAll;
  public faHome = faHome;

  public hideSideNav!: Observable<boolean>;
  public breadcrumbs = [];
  public pageTitle = '';
  public isMobile!: boolean;
  public collapsed = false;

  public user = {
    preferred_username: '',
  };

  siteLanguage: any = { key: 'it', label: 'Italiano' };
  languageList = [
    { key: 'it', label: 'Italiano' },
    { key: 'en', label: 'English' },
    { key: 'es', label: 'Español' },
  ];

  path = '';

  constructor(
    private router: Router,
    private navService: SidenavService,
    private breakpointObserver: BreakpointObserver,
    private transloco: TranslocoService,
    private location: Location,
    private userService: UserService
  ) {}

  control() {
    setTimeout(() => {
      let indexSidenav = this.items.findIndex((res: any) => this.myLocation.pathname.includes(res.url));
      this.selected_index = indexSidenav;

      this.control();
    }, 1000);
  }

  ngOnInit(): void {
    this.control();
    this.breakpointObserver.observe(['(max-width: 1023px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    if (localStorage.getItem('translocoLang')) {
      const localLang = localStorage.getItem('translocoLang');
      this.siteLanguage = this.languageList.find((f) => f.key === localLang);
    }

    this.hideSideNav = this.navService.getShowNav();
    this.router.events.subscribe((data) => {
      this.path = this.location.path();
      const state = this.router.getCurrentNavigation()?.extras.state;
      if (data instanceof ActivationStart) {
        this.pageTitle = data.snapshot.data['pageTitle'];
        this.collapsed = data.snapshot.data['collapsed'];
        if (state !== undefined) {
          this.breadcrumbs = state.breadcrumbs;
        } else {
          this.breadcrumbs = data.snapshot.data['breadcrumb'];
        }
      }
    });

    for (let i = 0; i < this.items.length; i++) {
      this.submenu.push(false);
    }
    this.getUserInfo();
    this.getCurrentRoute();
  }

  goToAccount() {
    window.location.replace('/profile');
  }

  getCurrentRoute() {
    let newIndex = this.items.findIndex((res) => this.location.path().includes(res.url));
    this.selected_index = newIndex;
  }

  manageAction(action: string) {
    if (action == 'LOGOUT') this.userService.logout();
  }

  toggleNav() {
    this.navService.toggleNavState();
  }

  changeLanguage(language: string) {
    const localLang = localStorage.getItem('translocoLang');
    this.transloco.setActiveLang(language);
    this.siteLanguage = language;
    document.location.reload();
  }

  // handleMenuClick(item: navItems) {
  //   if (item.children) {
  //     this.subItems = item.children;
  //     this.isSubmenuOpen = !this.isSubmenuOpen;
  //     this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event: any) => {
  //       this.isSubmenuOpen = false;
  //     });
  //   } else {
  //     this.router.navigate([item.url]);
  //   }
  // }

  isActive(url: string): boolean {
    return this.router.url.includes(url);
  }

  isActiveIndex(index?: number): boolean {
    return this.selected_index == index;
  }

  toggleSubmenu(index: number, menu_index?: number) {
    this.subMenuIndex = index;
    this.submenu[index] = !this.submenu[index];
    // if (this.submenu[index]) this.selected_index = menu_index;
  }

  closeAllSubmenu() {
    this.subMenuIndex = -1;
    this.submenu = this.submenu.map((el) => (el = false));
    this.getCurrentRoute();
  }

  isLogin() {
    if (this.router.url == '/auth/login') {
      return true;
    }
    return false;
  }

  async getUserInfo() {
    this.userService.getUser().then((value: any) => {
      value.subscribe((user: any) => {
        if (user != null) this.user = user;
      });
    });
  }
}
